var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgXpLevel9(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 35,
    height: 51,
    viewBox: "0 0 35 51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1422",
    "data-name": "Rectangle 1422",
    width: 35,
    height: 51,
    transform: "translate(0 0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3062",
    "data-name": "Group 3062",
    transform: "translate(-0.485 -0.384)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33071",
    "data-name": "Path 33071",
    d: "M151.071,172l5.587,5.959v11.918l-6.257-7.449Z",
    transform: "translate(-122.191 -139.81)",
    fill: "#ededed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33072",
    "data-name": "Path 33072",
    d: "M13.586,172,8,177.959v11.918l6.257-7.449Z",
    transform: "translate(-6.307 -139.81)",
    fill: "#ededed"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3061",
    "data-name": "Group 3061",
    transform: "translate(0.485 0.384)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3060",
    "data-name": "Group 3060",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33073",
    "data-name": "Path 33073",
    d: "M150.147,184.857a1.489,1.489,0,0,1-1.141-.532l-6.257-7.449a1.49,1.49,0,0,1-.346-1.054l.67-10.428a1.49,1.49,0,0,1,2.574-.923l5.587,5.959a1.488,1.488,0,0,1,.4,1.019v11.918a1.489,1.489,0,0,1-1.489,1.49m-4.732-9.439,3.242,3.86v-7.239l-2.831-3.02Z",
    transform: "translate(-116.164 -133.685)",
    fill: "#4a4e59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33074",
    "data-name": "Path 33074",
    d: "M1.489,184.857A1.489,1.489,0,0,1,0,183.367V171.449a1.489,1.489,0,0,1,.4-1.019l5.587-5.959a1.49,1.49,0,0,1,2.574.923l.67,10.428a1.491,1.491,0,0,1-.346,1.054L2.63,184.325a1.489,1.489,0,0,1-1.141.532m1.49-12.818v7.239l3.242-3.86-.411-6.4Z",
    transform: "translate(-0.282 -133.684)",
    fill: "#4a4e59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33075",
    "data-name": "Path 33075",
    d: "M52.9,48.968h6.034a60.294,60.294,0,0,0,.67-9.089C59.6,26.4,53.943,8,48.8,8S38,26.4,38,39.879a60.293,60.293,0,0,0,.67,9.089H52.9Z",
    transform: "translate(-31.206 -6.734)",
    fill: "#26a5dd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33076",
    "data-name": "Path 33076",
    d: "M74.931,48.968H77.88c.211-2.81.328-5.875.328-9.089C78.208,26.4,75.442,8,72.928,8s-5.279,18.4-5.279,31.879c0,3.214.117,6.279.328,9.089h6.954Z",
    transform: "translate(-55.333 -6.734)",
    fill: "#3ebfed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33077",
    "data-name": "Path 33077",
    d: "M76.564,126.21a4.98,4.98,0,1,1,4.448-4.952,4.72,4.72,0,0,1-4.448,4.952",
    transform: "translate(-58.969 -94.871)",
    fill: "#fc665e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33078",
    "data-name": "Path 33078",
    d: "M71.68,122.445a6.092,6.092,0,1,1,5.565-6.069,5.84,5.84,0,0,1-5.565,6.069m0-9.9a3.873,3.873,0,1,0,3.33,3.835,3.614,3.614,0,0,0-3.33-3.835",
    transform: "translate(-54.085 -89.989)",
    fill: "#4a4e59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33079",
    "data-name": "Path 33079",
    d: "M87.042,64.793a2.3,2.3,0,1,1,2.05-2.282,2.176,2.176,0,0,1-2.05,2.282",
    transform: "translate(-69.447 -49.237)",
    fill: "#4a4e59"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1421",
    "data-name": "Rectangle 1421",
    width: 3,
    height: 16,
    transform: "translate(16 34)",
    fill: "#4a4e59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33080",
    "data-name": "Path 33080",
    d: "M52.421,43.947H32.16a1.49,1.49,0,0,1-1.473-1.264A61.674,61.674,0,0,1,30,33.368a73.069,73.069,0,0,1,3.546-21.456C35.325,6.478,38.286,0,42.29,0s6.966,6.478,8.744,11.912a73.057,73.057,0,0,1,3.546,21.456,61.7,61.7,0,0,1-.687,9.315,1.49,1.49,0,0,1-1.473,1.264M33.454,40.968H51.127a59.63,59.63,0,0,0,.475-7.6,70.958,70.958,0,0,0-3.4-20.529c-2.368-7.234-4.833-9.86-5.913-9.86s-3.545,2.626-5.913,9.86a70.956,70.956,0,0,0-3.4,20.529,59.664,59.664,0,0,0,.475,7.6",
    transform: "translate(-24.695 -0.223)",
    fill: "#4a4e59"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXpLevel9);
export default __webpack_public_path__ + "static/media/xpLevel9.3d2d00438ebd9353bbbd5fc2efa181fb.svg";
export { ForwardRef as ReactComponent };